import React, { MouseEventHandler } from 'react'
import styled from 'styled-components'

import { CssUnit } from '@/types'
import { zIndex as zIndexValue } from '@/styles'
import CloseButton from '@/components/close-button'

const CloseButtonWrapper = styled.div<{ absolute?: boolean; zIndex?: CssUnit }>`
  height: ${props => (props.absolute ? '0' : '50px')};
  z-index: ${props => props.zIndex || zIndexValue.modal} !important;
`

type ModalCloseProps = {
  onClick: MouseEventHandler<HTMLButtonElement>
  absolute?: boolean
  top?: CssUnit
  right?: CssUnit
  zIndex?: CssUnit
}

const ModalClose: React.FC<ModalCloseProps> = ({
  onClick,
  absolute,
  top,
  right,
  ...rest
}) => (
  <CloseButtonWrapper {...rest} absolute={absolute}>
    <CloseButton onClick={onClick} top={top} right={right} />
  </CloseButtonWrapper>
)

export default ModalClose
